function forminator_fix() {
    const quizzInitButton = document.querySelector('button.forminator-quiz-start');

    if (quizzInitButton) {
        quizzInitButton.addEventListener('click', () => {
            setTimeout(() => {
                console.log("Starting the forminator fix");
                // Find the root form element; adjust selector to your page
                const el = document.querySelector('.forminator-ui, form.forminator-quiz');

                // If the plugin stored the instance in jQuery .data(), try common keys:
                const $el = jQuery(el);
                $el.data(); // Look at this object in console; expand it to find likely keys

                // Guess likely data keys (try a few variations that match the pluginName)
                const inst =
                    $el.data('forminatorFrontPagination') ||
                    $el.data('plugin_forminatorFrontPagination') ||
                    $el.data('ForminatorFrontPagination');

                // If you found an instance:
                let stepCounter = 0;
                const isMobile = window.screen.width <= 768 || navigator.userAgent.indexOf("Mobi") > -1;
   
                if (inst) {
                    console.log("Forminator Quiz Instance Found");
                    const originalGoTo = inst.constructor.prototype.go_to;
                    inst.constructor.prototype.go_to = function (...args) {
                        //THIS IS THE SAME CODE BUT ONLY MODIFIED boolean values
                        //args[0] is the step
                        //args[1] is scrollToTop (boolean)
                        args[1] = false;
                       
                        if(args[0]  == 1 && stepCounter == 0 && isMobile)
                        {
                            stepCounter++;
                            args[1] = true;
                        }
                        return originalGoTo.apply(this, args);
                    };
                }

            }, 450);

        });
    }

    else {
        console.log("QUIZ INIT BUTTON NOT FOUND");
    }
}

function progress_circle() {
    // Progress values per question
    const progressValues = [20, 40, 60, 80, 100];

    // Select all forminator page indicators
    const indicators = document.querySelectorAll(".forminator-page-indicator");

    indicators.forEach((indicator, index) => {
        const progress = progressValues[index] || 0;
        const total = indicators.length;
        const current = index + 1;

        // Replace content with span
        indicator.innerHTML = `<span class="forminator-ig-page-text">${current}/${total}</span>`;

        // Add extra class
        indicator.classList.add("forminator-ig-question-indicator");

        // Add inline --progress style
        indicator.style.setProperty('--progress', progress + '%');
    });
}

function render_custom_cta() {
    const sourceWrapper = document.querySelector('.group-quiz-custom-cta');
    if (!sourceWrapper) return;

    sourceWrapper.hidden = true;

    const showCTA = () => {

        const resultRoot = document.querySelector('.forminator-ig-quiz-result');
        if (!resultRoot) return false;

        sourceWrapper.hidden = false;

        console.log("SHOWING CTA....");

        return true;
    };

    // In case results are already rendered
    if (showCTA()) return;

    // Wait until Forminator injects the result DOM
    const observer = new MutationObserver(() => {
        if (showCTA()) {
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

function move_back_button() {
    const pageIndicators = document.querySelectorAll('.forminator-page-indicator.forminator-ig-question-indicator');
    pageIndicators.forEach((pageIndicator) => {

        const wrapper = document.createElement('div');
        wrapper.className = 'forminator-page-indicator-wrapper';

        // Insert wrapper before indicator
        pageIndicator.parentNode.insertBefore(wrapper, pageIndicator);

        wrapper.appendChild(pageIndicator);

    });

    const isQuizSubmitted = () => {
        return !!document.querySelector('.forminator-ig-quiz-result');
    };

    const getVisiblePagination = () => {
        return [...document.querySelectorAll('.forminator-pagination')]
            .find(el => getComputedStyle(el).visibility === 'visible');
    };

    const moveBackButton = () => {
        if (isQuizSubmitted()) return;

        const backButton = document.querySelector(
            '.forminator-button.forminator-button-back'
        );
        if (!backButton) return;

        const visiblePagination = getVisiblePagination();
        if (!visiblePagination) return;

        const indicator = visiblePagination.querySelector(
            '.forminator-page-indicator.forminator-ig-question-indicator'
        );
        if (!indicator || !indicator.parentNode) return;

        // Avoid unnecessary DOM moves
        if (backButton.previousElementSibling === indicator) return;

        indicator.parentNode.insertBefore(
            backButton,
            indicator.nextSibling
        );
    };

    const observer = new MutationObserver(moveBackButton);

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
    });

}

document.addEventListener("DOMContentLoaded", () => {
    progress_circle()
    render_custom_cta()
    move_back_button()
    forminator_fix()
});


